import styled from 'styled-components/macro';
import { ReactMultiEmail } from 'react-multi-email';
import { screenMd } from 'constants/styles/breakpoints';
import { colors } from 'constants/styles/colors';

export const StyledInputMultiEmail = styled(ReactMultiEmail)`
  &&& {
    background: ${colors.palette.Business_LightThemeGreyLighter};
    border-radius: 10px;
    border-color: ${colors.palette.Business_LightThemeGreyLighter};
    flex-grow: 0;
    max-height: 150px;
    min-height: 44px;
    padding: 10px;
    align-items: center;
    overflow: auto;
    /* The design's 44px field with the placeholder centred in it. */
    [data-placeholder] {
      top: 15px;
      left: 10px;
      line-height: 14px;
      color: ${colors.buttons.blackGray};
      font-size: 14px;
      height: 16px;
      ${screenMd} {
        font-size: 12px;
      }
    }
    input {
      background: ${colors.palette.Business_LightThemeGreyLighter};
      font-size: 16px;
      flex-grow: 1;
      ${screenMd} {
        font-size: 12px;
      }
    }

    [data-tag] {
      background: white;
      border-radius: 30px;
      font-size: 16px;
      font-weight: 500;
      padding: 8px 12px;
      line-height: 20px;
      ${screenMd} {
        padding: 5px 8px;
        font-size: 12px;
        line-height: 14px;
      }
      &.invalid {
        background: rgba(229, 42, 42, 0.1);
      }
    }

    [data-tag-handle] {
      color: #a793f6;
      font-size: 14px;
    }
  }
`;
